export default __webpack_public_path__ + "static/media/StandardPricing.1942e8eb.png";